import React, { useEffect, createElement } from 'react';
import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Extras } from '../components/Extras';
import { About } from '../components/About';
import { ServiceAreas } from '../components/ServiceAreas';
import { Reviews } from '../components/Reviews';
import { Gallery } from '../components/Gallery';
import { FAQ } from '../components/FAQ';
import { ContactForm } from '../components/ContactForm';
import { Contact } from '../components/Contact';
export function HomePage() {
  // Handle initial hash in URL on page load and SEO meta tags
  useEffect(() => {
    // Set SEO title
    document.title = "Mobile Car Detailing Near Me | Mike's Pro Detail Ventura County";
    // Set SEO meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', "Mike's Pro Detail offers 5-star mobile auto detailing in Los Angeles and Ventura County. Interior detailing, full detail, wash & wax, and ceramic wax protection. We come to you! Call (818) 381-9905.");
    // Inject JSON-LD Schema
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@graph': [{
        '@type': ['AutoRepair', 'LocalBusiness'],
        name: "Mike's Pro Detail",
        image: 'https://cdn.magicpatterns.com/uploads/8ujQRT1VS2FomWSs5Jvzhk/mikesprodetail2026logo.png',
        description: "Mike's Pro Detail offers 5-star mobile auto detailing in Los Angeles and Ventura County. Interior detailing, full detail, wash & wax, and ceramic wax protection. We come to you! Call (818) 381-9905.",
        telephone: '+18183819905',
        priceRange: '$160-$350',
        address: {
          '@type': 'PostalAddress',
          addressLocality: 'Los Angeles',
          addressRegion: 'CA',
          addressCountry: 'US'
        },
        geo: {
          '@type': 'GeoCoordinates',
          latitude: 34.0522,
          longitude: -118.2437
        },
        areaServed: [{
          '@type': 'City',
          name: 'Los Angeles'
        }, {
          '@type': 'AdministrativeArea',
          name: 'Ventura County'
        }, {
          '@type': 'City',
          name: 'Agoura Hills'
        }, {
          '@type': 'City',
          name: 'Thousand Oaks'
        }, {
          '@type': 'City',
          name: 'Calabasas'
        }],
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: 'Mobile Auto Detailing Services',
          itemListElement: [{
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Wash & Wax',
              description: 'A thorough exterior wash with hybrid ceramic protection for lasting shine'
            }
          }, {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Full Detail',
              description: 'Our most popular package — complete interior and exterior restoration'
            }
          }, {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Interior Detail',
              description: 'Deep clean, shampoo, and sanitize every surface inside your vehicle'
            }
          }]
        }
      }, {
        '@type': 'FAQPage',
        mainEntity: [{
          '@type': 'Question',
          name: 'What is mobile auto detailing?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "Mobile auto detailing is a professional car cleaning and restoration service that comes directly to your location. Mike's Pro Detail brings all equipment, water, and premium products to your home, office, or any convenient location in Los Angeles and Ventura County. No need to drop off your car — we handle everything on-site."
          }
        }, {
          '@type': 'Question',
          name: 'What areas do you serve?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We proudly serve Los Angeles and Ventura County, including Agoura Hills, Thousand Oaks, Calabasas, Woodland Hills, Westlake Village, Encino, Tarzana, Sherman Oaks, Simi Valley, Moorpark, Camarillo, and Oxnard. Contact us to confirm service availability in your area.'
          }
        }, {
          '@type': 'Question',
          name: 'How long does a full detail take?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'A full detail typically takes 3-4 hours depending on the size and condition of your vehicle. Our wash and wax service takes about 1.5-2 hours, and interior detailing takes 2-3 hours. We never rush — quality results take proper time and attention.'
          }
        }, {
          '@type': 'Question',
          name: 'What products do you use?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'We use only premium, eco-friendly detailing products including professional-grade shampoos, clay bar treatments, and hybrid ceramic wax for long-lasting protection. Our products are safe for all paint types, leather, fabric, and vinyl surfaces.'
          }
        }, {
          '@type': 'Question',
          name: 'How much does mobile detailing cost?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Our packages start at $160 for a wash and wax on small/mid-size vehicles. Interior detailing starts at $180, and our most popular full detail package starts at $300. SUV and crossover pricing is slightly higher. Contact Mike directly at (818) 381-9905 for an exact quote.'
          }
        }, {
          '@type': 'Question',
          name: 'Do I need to provide water or electricity?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "No! Mike's Pro Detail is fully self-contained. We bring our own water supply, generator, and all necessary equipment. All we need is access to your vehicle and a reasonable amount of space to work."
          }
        }, {
          '@type': 'Question',
          name: 'How often should I get my car detailed?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "For most vehicles, we recommend a full detail every 3-6 months and a wash and wax every 4-6 weeks to maintain your car's appearance and protect the paint. Vehicles exposed to heavy sun, tree sap, or frequent use may benefit from more frequent service."
          }
        }, {
          '@type': 'Question',
          name: 'How do I book an appointment?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: "Booking is easy! Simply call or text Mike at (818) 381-9905. We offer flexible scheduling including weekends. Mike will discuss your vehicle's needs, provide a quote, and find a time that works for you."
          }
        }]
      }]
    });
    document.head.appendChild(schemaScript);
    const hash = window.location.hash.slice(1);
    if (hash) {
      setTimeout(() => {
        const element = document.getElementById(hash);
        if (element) {
          const navHeight = 64;
          const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - navHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
    return () => {
      document.head.removeChild(schemaScript);
    };
  }, []);
  return <main className="min-h-screen w-full bg-black text-white selection:bg-red-600 selection:text-white scroll-smooth" data-id="element-482">
      <Navigation data-id="element-483" />
      <Hero data-id="element-484" />
      <Services data-id="element-485" />
      <Extras data-id="element-486" />
      <About data-id="element-487" />
      <ServiceAreas data-id="element-488" />
      <Reviews data-id="element-489" />
      <Gallery data-id="element-490" />
      <FAQ data-id="element-491" />
      <ContactForm data-id="element-492" />
      <Contact data-id="element-493" />
    </main>;
}